import React, { useState } from "react";
import { Mail, X, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const DISMISS_KEY = "orio_verify_dismissed_until";

export default function EmailVerifyBanner() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => {
    try {
      const until = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
      return until && until > Date.now();
    } catch { return false; }
  });
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified || hidden) return null;

  const resend = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/auth/send-verify");
      if (data?.already) {
        toast.success("La tua email è già verificata");
      } else if (data?.sent) {
        toast.success("Email di verifica inviata. Controlla la posta.");
      } else {
        toast.success("Link di verifica generato. Controlla la posta o ricaricala tra poco.");
      }
    } catch {
      toast.error("Impossibile inviare ora. Riprova fra poco.");
    } finally {
      setSending(false);
    }
  };

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now() + 24 * 3600 * 1000));
    } catch {/* ignore */}
    setHidden(true);
  };

  return (
    <div
      data-testid="verify-banner"
      className="relative w-full"
      style={{
        background: "linear-gradient(90deg, rgba(255,176,32,0.15) 0%, rgba(255,176,32,0.06) 100%)",
        borderBottom: "1px solid rgba(255,176,32,0.25)",
      }}
    >
      <div className="max-w-7xl mx-auto px-5 py-2.5 flex flex-wrap items-center gap-3 text-sm">
        <Mail className="h-4 w-4 shrink-0" style={{ color: "#FFB020" }} />
        <span className="flex-1 min-w-[200px] text-[#1A1A1A]">
          <span className="text-[#1A1A1A] font-medium">Conferma la tua email</span>
          <span className="text-[#9A9A9A] hidden sm:inline"> · gli alert SOS arrivano solo agli account verificati.</span>
        </span>
        <button
          data-testid="verify-resend"
          onClick={resend}
          disabled={sending}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-medium border transition-colors"
          style={{
            background: "rgba(255,176,32,0.15)",
            borderColor: "rgba(255,176,32,0.45)",
            color: "#FFB020",
          }}
        >
          <Send className="h-3 w-3" /> {sending ? "Invio…" : "Invia link"}
        </button>
        <button
          data-testid="verify-dismiss"
          onClick={dismiss}
          aria-label="Nascondi per 24h"
          className="h-7 w-7 rounded-full bg-[#F4EFE6] hover:bg-[#F0EBE3] flex items-center justify-center"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
